import { render, staticRenderFns } from "./AreaFilter.vue?vue&type=template&id=fa212646&"
import script from "./AreaFilter.vue?vue&type=script&lang=js&"
export * from "./AreaFilter.vue?vue&type=script&lang=js&"
import style0 from "./AreaFilter.vue?vue&type=style&index=0&id=fa212646&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports